<template>
  <a-card :bordered="false">
    <search-page-view
      :col="3"
      ref="searchTable"
      :itemNames="['search_name','search_state']"
      :columns="getColumns()"
      :queryParams="queryParams"
      row-key="proId"
      :showResetButton="true"
      @reset="resetChange"
      :leftSpace="30"
      :requestPromise="getFliggyListPromise"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <a-form-item slot="search_name" label="商品名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.proName" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="search_state" label="商品类型" v-bind="searchItemLayout">
        <a-select
          v-model="queryParams.proType"
          placeholder="请选择"
          allowClear
          style="width: 100%">
          <a-select-option v-for="item in proTypeList" :value="item.code" :key="item.code">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="operation">
        <a-button style="margin-right: 10px;" type="primary" @click="onShowModal" icon="plus">新建</a-button>
        <a-dropdown-button>
          批量操作
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="addOnSale(1)">批量加价</a-menu-item>
            <a-menu-item key="0" @click="addOnSale(0)">批量减价</a-menu-item>
          </a-menu>
        </a-dropdown-button>
      </a-form-item>
      <span slot="action" slot-scope="rowItem">
        <a @click="onPreview(rowItem.record.feiZhuProId)">预览</a>
        <a-divider type="vertical"></a-divider>
        <a-popconfirm title="是否要删除当前行" @confirm="onDeleteType(rowItem.record.pushId)">
          <a>删除</a>
        </a-popconfirm>
      </span>
    </search-page-view>
    <selected-product-dialog
      :show="visible"
      ref="pageList"
      :itemNames="['search_proName','search_proId']"
      :query-params="selectedQueryParams"
      :requestPromise="loadPromise"
      row-key="proId"
      @close="onCancel"
      :columns="getGoodsColumns()"
      :rowSelection="{ selectedRowKeys: selectedDialogRowKeys, onChange: onSelectDialogChange }"
    >
      <a-form-item label="商品名称" slot="search_proName" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称"></a-input>
      </a-form-item>
      <a-form-item label="商品ID" slot="search_proId" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proId" style="width: 170px" placeholder="请输入商品ID"></a-input>
      </a-form-item>
      <!--      <a-form-item label="商品分类" slot="search_proCate" v-bind="currentDialogLayout">-->
      <!--        <a-select v-model="selectedQueryParams.proType" placeholder="请选择" style="width: 100%">-->
      <!--          <a-select-option v-for="item in proTypeList" :value="item.code" :key="item.code">-->
      <!--            {{item.name}}-->
      <!--          </a-select-option>-->
      <!--        </a-select>-->
      <!--      </a-form-item>-->
      <template slot="proType" slot-scope="rowItem">{{ rowItem.record.proType | getAllProductTypeName }}</template>
      <div slot="footer" class="btns-bottom">
        <a-button @click="onCancel">取消</a-button>
        <a-button type="primary" class="ml10" :loading="submitLoading" @click="onSelectedResult">确定</a-button>
      </div>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import searchForm from '../../../../utils/mixins/searchFormMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'
import fliggyMixins from './fliggyMixins'

export default {
  name: 'GoodsDelivery',
  mixins: [searchForm, fliggyMixins],
  components: {
    SelectedProductDialog
  },
  data() {
    return {
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        proType: undefined,
        proName: ''
      },
      selectedQueryParams: {
        proStatus: 1,
        proType: 4
      },
      submitLoading: false,
      selectedRowKeys: [],
      selectedDialogRowKeys: [],
      selectedRows: [],
      visible: false,
      loadPromise: params => this.getListPromise(params),
      selectShopStr: '',
      proIdStr: ''
    }
  },
  mounted() {

  },
  methods: {
    //表格数据
    getListPromise(params) {
      return this.getHttpServices().getProService().post('api/v2/productManage/findProductList', params)
    },
    getGoodsColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '60%'
        },
        {
          title: '商品类型',
          dataIndex: 'proType',
          scopedSlots: { customRender: 'proType' }
        }
      ]
    },
    addOnSale(type) {
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        this.openNewPage('BatchAddOnSale', {
          serverUniqueId: this.$route.query.serverUniqueId,
          serverId: this.$route.query.serverId,
          type: type,
          proIdStr: this.proIdStr,
          selectShopStr: this.selectShopStr
        })
      } else {
        this.$message.error('请选择商品')
      }
    },
    onShowModal() {
      this.visible = true
      this.selectedDialogRowKeys = []
    },
    onCancel() {
      this.visible = false
    },
    resetChange() {
      this.queryParams = {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        proType: undefined,
        proName: ''
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.proIdStr = this.selectedRowKeys.join(',')
      this.getLogUtils().logWithTag('selectedRowKeys', this.selectedRowKeys)
      this.getLogUtils().logWithTag('selectedRows', this.selectedRows)
      let shopList = this.selectedRows.map(item => {
        return {
          authId: item.authId,
          taoBaoUserNick: item.taoBaoUserNick
        }
      })
      this.getLogUtils().logWithTag('shopList', shopList)
      if (shopList && shopList.length > 0) {
        let obj = {}
        let peon = shopList.reduce((cur, next) => {
          obj[next.authId] ? '' : (obj[next.authId] = true && cur.push(next))
          return cur
        }, []) //设置cur默认类型为数组，并且初始值为空的数组
        this.getLogUtils().logWithTag('peon', peon)
        this.selectShopStr = JSON.stringify(peon)
      }
    },
    getFliggyListPromise(params) {
      return this.getHttpServices().getServerApiService().post('feizhu/link/queryPushList', params)
    },
    onDeleteType(pushId) {
      let params = {
        pushId: pushId,
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      this.getHttpServices().getServerApiService().post('feizhu/link/removePushPro', params)
        .then(res => {
          this.$message.success('删除成功')
          this.$refs.searchTable.refresh(true)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '28%'
        },
        {
          title: '类型',
          dataIndex: 'proTypeName'
        },
        {
          title: '推送店铺',
          dataIndex: 'taoBaoUserNick'
        },
        {
          title: '添加时间',
          dataIndex: 'addTime'
        },
        {
          title: '状态',
          dataIndex: 'shopProStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '108px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    onPreview(id) {
      window.open('https://items.fliggy.com/item.htm?id=' + id)
    },
    onSelectedResult() {
      if (this.selectedDialogRowKeys && this.selectedDialogRowKeys.length > 0) {
        this.onPushFeiZhuProduct()
      } else {
        this.$message.error('请选择商品')
      }
    },
    onPushFeiZhuProduct() {
      let params = {
        proIds: this.selectedDialogRowKeys,
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      this.submitLoading = true
      this.getHttpServices().getServerApiService().post('feizhu/link/pushFeiZhuProduct', params)
        .then(res => {
          this.getLogUtils().logWithTag('onPushFeiZhuProduct', res)
          if (res) {
            this.$message.success(res)
          }
          this.$refs.searchTable.refresh(true)
          this.onCancel()
        })
        .catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    onSelectDialogChange(selectedRowKeys, selectedRows) {
      this.selectedDialogRowKeys = selectedRowKeys
      this.getLogUtils().logWithTag('selectedRowKeys', this.selectedDialogRowKeys)
    }
  }
}
</script>

<style scoped>
.btns-bottom {
  margin-top: 15px;
  text-align: right;
}

.ml10 {
  margin-left: 10px;
}
</style>